var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 806 103.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: #171f4a;\n      }\n\n      .cls-4 {\n        fill: #224ce1;\n      }\n\n      .cls-5 {\n        fill: #1938a5;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 170.2,
    height: 103.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 96.8,
    y1: 163.4,
    x2: 26.4,
    y2: 83.7,
    gradientTransform: "translate(0 174) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#224be1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12297b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 19.6,
    cy: 82.5,
    rx: 19.6,
    ry: 19.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.8,25.8c-1.3,7.2-2.5,14.5-7.1,19.9l-.5.6c-2.1,2.5-4.8,4.4-7.7,6-6.6,3.5-14.8,3.6-21.2-.1-2.3-1.3-4.5-3-6.2-5-4.8-5.6-5.8-13.2-6.9-20.7-.4-2.8-.8-5.7-1.4-8.4-.7-3.4-2.3-6.7-4.8-9.6C46-1,31.8-2.2,22.2,5.7c-9.5,7.9-10.8,22-2.8,31.4,2.9,3.4,6.5,5.7,10.4,6.9,1.9.6,3.8,1.1,5.7,1.6,7.4,2,14.9,4,19.7,9.6,4.9,5.8,5.5,13.8,6.1,21.6.1,1.5.2,2.9.4,4.4,0,2.4.6,4.7,1.4,7,.9,2.4,2.2,4.6,3.9,6.6,8,9.4,22.2,10.7,31.8,2.7,5.2-4.3,8-10.5,8.1-16.8.1-1.3.2-2.7.3-4,.6-7.8,1.2-15.8,6.1-21.6,4.9-5.8,12.8-7.7,20.5-9.7,2.1-.5,4.1-1,6-1.6,4.1-1.2,7.9-3.6,10.9-7,8-9.4,6.8-23.5-2.8-31.4-9.5-7.9-23.8-6.7-31.8,2.7-2.2,2.6-3.7,5.5-4.5,8.6-.8,2.9-1.3,5.9-1.8,9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 150.6,
    cy: 82.5,
    rx: 19.6,
    ry: 19.4
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.7,100.4v-59c-.1,0-29.4,48.8-29.4,48.8h-7.4l-29.2-48.1v58.3h-15.8V11.4h13.6l35.3,59,34.7-59h13.6v89c.1,0-15.5,0-15.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.6,32.5h15.9v67.9h-15.9V32.5ZM341.6,21.3c-2.9,0-5.3-.9-7.2-2.7-1.9-1.9-2.9-4.2-2.9-6.9s1-5,2.9-6.7c1.9-1.9,4.4-2.8,7.2-2.8s5.3.9,7.2,2.7c1.9,1.7,2.9,3.9,2.9,6.5s-1,5.2-2.9,7.1c-1.9,1.9-4.3,2.8-7.2,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.6,31.7c8.6,0,15.4,2.5,20.6,7.5,5.2,5,7.8,12.4,7.8,22.3v38.9h-15.9v-36.9c0-5.9-1.4-10.4-4.2-13.4-2.8-3.1-6.8-4.6-11.9-4.6s-10.5,1.8-13.9,5.3c-3.4,3.5-5.1,8.5-5.1,15.1v34.3h-15.9V32.5h15.1v8.8c2.6-3.1,5.9-5.5,9.9-7.1,4-1.6,8.5-2.4,13.5-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M520,6v94.4h-15.3v-8.8c-2.6,3.2-5.9,5.6-9.8,7.3-3.8,1.6-8.1,2.4-12.7,2.4s-12.4-1.4-17.7-4.3c-5.2-2.9-9.2-7-12.2-12.2-3-5.3-4.4-11.4-4.4-18.3s1.5-12.9,4.4-18.2c3-5.3,7-9.3,12.2-12.2,5.3-2.9,11.1-4.3,17.7-4.3s8.6.8,12.3,2.3c3.7,1.5,6.9,3.8,9.5,6.9V6h15.9ZM484.1,87.7c3.8,0,7.2-.8,10.3-2.5,3.1-1.8,5.5-4.3,7.2-7.5,1.8-3.2,2.7-7,2.7-11.2s-.9-8-2.7-11.2c-1.8-3.2-4.2-5.7-7.2-7.4-3.1-1.8-6.5-2.7-10.3-2.7s-7.2.9-10.3,2.7c-3.1,1.7-5.5,4.2-7.2,7.4-1.8,3.2-2.7,7-2.7,11.2s.9,8,2.7,11.2c1.8,3.2,4.2,5.7,7.2,7.5,3.1,1.7,6.5,2.5,10.3,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M582.7,96.7c-1.9,1.5-4.2,2.7-6.9,3.4-2.6.8-5.4,1.1-8.4,1.1-7.5,0-13.2-2-17.3-5.9-4.1-3.9-6.1-9.6-6.1-17v-32.7h-11.2v-12.7h11.2v-15.5h15.9v15.5h18.2v12.7h-18.2v32.3c0,3.3.8,5.9,2.4,7.6,1.6,1.7,3.9,2.5,7,2.5s6.5-.9,8.9-2.8l4.4,11.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M655.1,66.8c0,1.1,0,2.7-.3,4.7h-53.3c.9,5,3.3,9,7.2,12,4,2.9,8.9,4.3,14.7,4.3s13.6-2.5,18.4-7.4l8.5,9.8c-3.1,3.6-6.9,6.4-11.6,8.3-4.7,1.9-9.9,2.8-15.8,2.8s-14-1.5-19.7-4.5c-5.7-3-10.1-7.1-13.2-12.3-3.1-5.3-4.6-11.4-4.6-18.1s1.5-12.6,4.4-17.8c3-5.3,7.2-9.5,12.6-12.5,5.3-3,11.4-4.5,18-4.5s12.5,1.5,17.7,4.5c5.3,2.9,9.3,7,12.2,12.3,3,5.3,4.4,11.4,4.4,18.3ZM620.8,44.4c-5.1,0-9.4,1.5-13,4.6-3.5,3-5.6,7-6.4,12h38.5c-.7-4.9-2.8-8.9-6.2-12-3.5-3.1-7.8-4.6-13-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M699.3,101.3c-7,0-13.3-1.5-18.9-4.5-5.6-3-10-7.1-13.1-12.3-3.1-5.3-4.7-11.4-4.7-18.1s1.6-12.7,4.7-17.9c3.1-5.3,7.5-9.4,13-12.3,5.6-3,11.9-4.5,19.1-4.5s12.5,1.4,17.5,4.1c5.1,2.7,8.9,6.6,11.4,11.7l-12.2,7.1c-1.9-3.1-4.4-5.5-7.4-7-2.9-1.6-6.1-2.4-9.5-2.4-5.9,0-10.8,2-14.7,5.9-3.9,3.8-5.8,8.9-5.8,15.4s1.9,11.6,5.7,15.5c3.9,3.8,8.9,5.7,14.9,5.7s6.7-.8,9.5-2.3c3-1.6,5.4-4,7.4-7.1l12.2,7.1c-2.6,5.1-6.5,9-11.6,11.8-5,2.7-10.8,4.1-17.4,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M777.7,31.7c8.6,0,15.4,2.5,20.6,7.5,5.2,5,7.8,12.4,7.8,22.3v38.9h-15.9v-36.9c0-5.9-1.4-10.4-4.2-13.4-2.8-3.1-6.8-4.6-11.9-4.6s-10.5,1.8-13.9,5.3c-3.4,3.5-5.1,8.5-5.1,15.1v34.3h-15.9V6h15.9v34.3c2.6-2.8,5.8-4.9,9.7-6.4,3.9-1.5,8.2-2.3,13-2.3Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.4f9163084aaf7a46b3937a90977117d7.svg";
export { ForwardRef as ReactComponent };